export class UiModuleConfigurationHelpers {
  static insertEscapeCharacters(inputString: string): string {
    let isInsideBrackets = false;
    let result = '';

    for (let i = 0; i < inputString.length; i++) {
      const char = inputString[i];

      if (char === '[') {
        isInsideBrackets = true;
      } else if (char === ']') {
        isInsideBrackets = false;
      }

      if (char === ',' && isInsideBrackets) {
        result += "'";
      } else {
        result += char;
      }
    }

    return result;
  }

  static replaceEscapeCharacters(arr: string[]): string[] {
    const result: string[] = [];

    for (const item of arr) {
      const replacedItem = item.replace(/\[(.*?)\]/g, (match, p1) => {
        return `[${p1.replace(/'/g, "',")}]`;
      });
      result.push(replacedItem);
    }

    return result;
  }
}
